import { DateTime } from 'luxon';

export const tableDateFormatter = (date: string, timeZone: string = 'UTC'): string | null => {
  if (!date) return null;
  const format = "dd 'de' LLLL 'de' yyyy, h:mm a";
  const dateFormatter = DateTime.fromISO(date, { zone: timeZone }).setLocale('es').toFormat(format);
  return dateFormatter;
};

export const tableDateFormatterWithoutTime = (
  date: string | Date,
  timeZone: string = 'UTC',
): string | null => {
  if (!date) return null;
  const format = "dd 'de' LLLL 'de' yyyy";
  const timeZoneParsed = !timeZone || timeZone.length === 0 ? 'UTC' : timeZone;
  const dateParsed = typeof date === 'string' ? date : date.toISOString();
  const dateFormatter = DateTime.fromISO(dateParsed, { zone: timeZoneParsed })
    .setLocale('es')
    .toFormat(format);
  return dateFormatter;
};

export const formatName = (name?: string, lastname?: string): string => {
  const parts = [name, lastname].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : '-';
};

export const tableShortDateFormatter = (date: string) => {
  if (!date) return '-';
  if (date === 'now') {
    return DateTime.now().toFormat('dd/MM/yyyy');
  }
  const formattedDate = DateTime.fromISO(date).toFormat('dd/MM/yyyy');
  return formattedDate;
};

export const getCoachLabel = (appId: 'mentoring' | 'coaching' = 'mentoring') => {
  let label = {
    coach: 'coach',
    Coach: 'Coach',
    Coaching: 'Coaching',
    coaching: 'coaching',
    Coachee: 'Coachee',
    coachee: 'coachee',
  };
  if (appId === 'mentoring') {
    label = {
      coach: 'mentor',
      Coach: 'Mentor',
      Coaching: 'Mentoring',
      coaching: 'mentoring',
      Coachee: 'Mentee',
      coachee: 'mentee',
    };
  }
  return label;
};
